import type { CSSProperties } from "react";

interface TimeredStateCssProperties extends CSSProperties {
    "--timered-animation-duration": string;
}

/**
 * Создаёт объект стилей для анимации timered.
 *
 * @param {number} duration - продолжительность анимации в миллисекундах.
 * @returns {TimeredStateCssProperties} - объект со стилями для анимации.
 */

export const getTimeredStyles = (
    duration: number,
): TimeredStateCssProperties => {
    const styles: TimeredStateCssProperties = {
        "--timered-animation-duration": `${duration}ms`,
    };

    return styles;
};
